import React from "react";
import styles from "./CarReportTable.module.css";

export type CarReportRow = {
    vehicleNumber: string;
    contractor: string;

    addressInZone: string;

    date: string;
    isScheduleDeviation?: boolean;
    deviationReason?: string;

    collectionMethod: string; // КП / подворовой / КГМ
};

type CarReportProps = {
    data: CarReportRow[];
};

const columns = [
    "Характеристики автомобиля",
    "Адреса внутри геозоны",
    "Дата вывоза",
    "Статус графика",
    "Причина отклонения",
    "Способ сбора",
];

const CarReportTable = ({ data }: CarReportProps) => {
    const firstRow = data[0];

    return (
        <div className={styles.tableWrapper}>
            {firstRow && (
                <div className={styles.carHeader}>
                    <div className={styles.carTitle}>
                        Характеристики автомобиля
                    </div>
                    <div className={styles.carMeta}>
                        Номер автомобиля: <strong>{firstRow.vehicleNumber}</strong>
                    </div>
                    <div className={styles.carMeta}>
                        Подрядчик / организация:{" "}
                        <strong>{firstRow.contractor}</strong>
                    </div>
                </div>
            )}

            <div className={styles.table}>
                <div className={styles.header}>
                    {columns.map(col => (
                        <div key={col} className={styles.th}>
                            {col}
                        </div>
                    ))}
                </div>

                <div className={styles.body}>
                    {data.length > 0 ? (
                        data.map((row, i) => {
                            const isDeviation = !!row.isScheduleDeviation;

                            return (
                                <div
                                    key={i}
                                    className={`${styles.tr} ${
                                        isDeviation ? styles.deviationRow : ""
                                    }`}
                                >
                                    <div className={styles.td}>
                                        {row.addressInZone}
                                    </div>

                                    <div
                                        className={`${styles.td} ${styles.dateCell}`}
                                    >
                                        {row.date}
                                    </div>

                                    <div className={styles.td}>
                                        {isDeviation
                                            ? "Отклонение от графика"
                                            : "По графику"}
                                    </div>

                                    <div className={styles.td}>
                                        {row.deviationReason || "—"}
                                    </div>

                                    <div className={styles.td}>
                                        {row.collectionMethod}
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className={styles.empty}>Нет данных</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CarReportTable;


